'use client'

import { useGetSocialProof } from "@/api/social-proof/read";
import { ChatBubbleOutlineOutlined, FavoriteBorderOutlined, ShareOutlined } from "@mui/icons-material";
import { FormControlLabel, Stack } from "@mui/material";
import { ShareArrowIcon } from "@vidstack/react/icons";

export type PlayerSocialProofProps = {
  entityId: string,
  onLike?: () => void,
  onComment?: () => void,
  onShare?: () => void
};

export function PlayerSocialProof({ entityId, onLike, onComment, onShare }: PlayerSocialProofProps) {
  const { data: entitySocialProof } = useGetSocialProof(entityId);

  const LIKES_COUNT = entitySocialProof?.likesCount ?? 0;
  const COMMENTS_COUNT = entitySocialProof?.commentsCount ?? 0;
  const SHARE_COUNT = entitySocialProof?.sharesCount ?? 0;

  return (
    <Stack 
      direction="row" 
      marginBottom="14px" 
      justifyContent="space-between" 
      width="100%">
      <FormControlLabel
        control={
          <FavoriteBorderOutlined fontSize="small"
            sx={{
              width: '24px',
              height: '24px',
              marginRight: '8px'
            }}
          />
        }
        label={
          LIKES_COUNT
        }
        sx={{
          minHeight: 24,
          padding: '0 12px',
          margin: '12px 0',
          flex: 1,
          justifyContent: 'center'
        }}
        onClick={onLike}
      />
      <FormControlLabel
        control={
          <ChatBubbleOutlineOutlined fontSize="small"
            sx={{
              width: '24px',
              height: '24px',
              marginRight: '8px'
            }}
          />
        }
        label={
          COMMENTS_COUNT
        }
        sx={{
          minHeight: 24,
          padding: '0 12px',
          margin: '12px 0',
          flex: 1,
          justifyContent: 'center'
        }}
        onClick={onComment}
      />
      <FormControlLabel
        control={
          <ShareOutlined fontSize="small"
            sx={{
              width: '24px',
              height: '24px',
              marginRight: '8px'
            }}
          />
        }
        label={
          SHARE_COUNT
        }
        sx={{
          minHeight: 24,
          padding: '0 12px',
          margin: '12px 0',
          flex: 1,
          justifyContent: 'center'
        }}
        onClick={onShare}
      />
    </Stack>
  );
}